import React from 'react';
import { Col, Row } from 'react-bootstrap';

const InfoDataOnTicketStamping = ({ data }) => {
  if (!data?.title) {
    return <></>;
  }

  const {
    title,
    anuncio,
    empresa,
    rfc,
    direccion,
    fecha_emision,
    fecha_pago,
    unidad,
    matricula,
    nombre,
    curp,
    servicio,
    valor,
    numero_init,
    numero_mark,
    numero_end,
    recibo,
  } = data;

  return (
    <Row>
      <Col>
        {title && (
          <>
            <strong className="h5">{title} </strong>
            <br />
          </>
        )}

        {anuncio && (
          <>
            <br />
            {anuncio}
          </>
        )}

        {empresa && (
          <>
            <br />
            <strong>Empresa: </strong> {empresa}
          </>
        )}

        {rfc && (
          <>
            <br />
            <strong>RFC: </strong>
            {rfc}
          </>
        )}

        {direccion && (
          <>
            <br />
            <strong>Dirección: </strong>
            {direccion}
          </>
        )}

        {fecha_emision && (
          <>
            <br />
            <strong>Fecha de Emisión: </strong>
            {fecha_emision}
          </>
        )}

        {fecha_pago && (
          <>
            <br />
            <strong>Fecha de Pago: </strong>
            {fecha_pago}
          </>
        )}

        {unidad && (
          <>
            <br />
            <strong>Unidad: </strong>
            <span className="badge badge-warning">{unidad}</span>
          </>
        )}

        {matricula && (
          <>
            <br />
            <strong>Matricula: </strong>
            {matricula}
          </>
        )}

        {nombre && (
          <>
            <br />
            <strong>Nombre: </strong>
            {nombre}
          </>
        )}

        {curp && (
          <>
            <br />
            <strong>CURP: </strong>
            {curp}
          </>
        )}

        {servicio && (
          <>
            <br />
            <strong>Descripción del servicio: </strong>
            {servicio}
          </>
        )}

        {valor && (
          <>
            <br />
            <strong>Valor: </strong>
            <span className="badge badge-warning">{valor}</span>
          </>
        )}

        {numero_mark && (
          <>
            <br />
            <div>
              <strong>Número de referencia: </strong>
              {numero_init}
              <span className="badge badge-warning">{numero_mark}</span>
              {numero_end}
            </div>
          </>
        )}

        {recibo && (
          <>
            <strong>Recibo: </strong>
            {recibo}
            <br />
          </>
        )}
      </Col>
    </Row>
  );
};

export default InfoDataOnTicketStamping;
